export default "__VITE_ASSET__212051de__"